import { CollectionPath } from '@typings/collections.enum';
import fire from '@store/firebase';
const firestore = fire.firestore();

export enum WalletHistoryType {
  EVENT = 'event',
  LOG = 'log',
  BETTING = 'betting',
  MASTER = 'master',
  ITEM = 'item',
  LEVELUP = 'levelup',
  PETLEVELUP = 'petlevelup',
  PETACTION = 'petaction',
  REINFORCE = 'reinforce',
  EXPLORATION = 'exploration',
  QUEST = 'quest',
  QUEST_ITEM = 'quest_item',
  QUEST_STAT = 'quest_stat',
}

const walletHistoryTypeMap = {
  [WalletHistoryType.BETTING]: '베팅 정산',
  [WalletHistoryType.LOG]: '로그',
  [WalletHistoryType.EVENT]: '이벤트 지급',
  [WalletHistoryType.MASTER]: '마스터 지급',
  [WalletHistoryType.ITEM]: '아이템 지급',
  [WalletHistoryType.LEVELUP]: '레벨업 보상',
  [WalletHistoryType.PETLEVELUP]: '펫 레벨업 보상',
  [WalletHistoryType.PETACTION]: '펫 액션 보상',
  [WalletHistoryType.REINFORCE]: '장비 강화',
  [WalletHistoryType.EXPLORATION]: '탐색 보상',
  [WalletHistoryType.QUEST]: '퀘스트 보상',
  [WalletHistoryType.QUEST_ITEM]: '퀘스트 아이템 보상',
  [WalletHistoryType.QUEST_STAT]: '퀘스트 스탯 보상',
};

type Props = {
  uid: string;
  price: number;
  type: WalletHistoryType;
  memo?: string;
};

export async function addWalletHistoryByType({
  uid,
  price,
  type = WalletHistoryType.EVENT,
  memo,
}: Props) {
  // 유저의 재화 히스토리에 로그 추가 user/:uid/walletHistory
  return await firestore
    .collection(CollectionPath.USERS)
    .doc(uid)
    .collection('walletHistory')
    .add({
      price: price,
      memo: memo || '관리자',
      type: type || WalletHistoryType.MASTER,
      text: walletHistoryTypeMap[type],
      createdAt: new Date(),
    });
}
